export default "__VITE_ASSET__95cb5fc5__"